// @ts-nocheck
import * as React from "react";

const Search: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m19.485 20.154-6.261-6.261a5.5 5.5 0 0 1-1.725.988c-.65.233-1.303.35-1.96.35-1.601 0-2.957-.554-4.066-1.663-1.11-1.11-1.664-2.464-1.664-4.064 0-1.601.554-2.957 1.663-4.068C6.58 4.325 7.935 3.77 9.536 3.77c1.6 0 2.957.554 4.068 1.664 1.11 1.109 1.666 2.465 1.666 4.066 0 .695-.123 1.367-.37 2.018a5.48 5.48 0 0 1-.968 1.667l6.261 6.261-.708.708ZM9.54 14.231c1.327 0 2.447-.457 3.36-1.37.914-.914 1.371-2.034 1.371-3.36 0-1.328-.457-2.448-1.37-3.361-.914-.914-2.034-1.37-3.36-1.37-1.328 0-2.448.456-3.361 1.37-.914.913-1.37 2.033-1.37 3.36s.456 2.447 1.37 3.36c.913.914 2.033 1.371 3.36 1.371Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Search);
